import AnnouncementBar from '@/components/feature/AnnouncementBar';
import Navbar from '@/components/feature/Navbar';
import HeroBanner from '@/components/feature/HeroBanner';
import FlashDeals from '@/components/feature/FlashDeals';
import CategoryGrid from '@/components/feature/CategoryGrid';
import ProductShowcase from '@/components/feature/ProductShowcase';
import FeatureHighlights from '@/components/feature/FeatureHighlights';
import BrandShowcase from '@/components/feature/BrandShowcase';
import SellerBanner from '@/components/feature/SellerBanner';
import AppDownload from '@/components/feature/AppDownload';
import Newsletter from '@/components/feature/Newsletter';
import Footer from '@/components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-primary-500">
      {/* Top Announcement */}
      <AnnouncementBar />

      {/* Navigation */}
      <Navbar />

      <main>
        {/* Hero Banner Slider */}
        <HeroBanner />

        {/* Feature Highlights - Trust badges */}
        <FeatureHighlights />

        {/* Flash Deals Section */}
        <FlashDeals />

        {/* Shop by Category */}
        <CategoryGrid />

        {/* Trending / New / Best Sellers Tabs */}
        <ProductShowcase />

        {/* Brand Showcase */}
        <BrandShowcase />

        {/* Seller Banner CTA */}
        <SellerBanner />

        {/* App Download */}
        <AppDownload />

        {/* Newsletter Subscription */}
        <Newsletter />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}